var _linearGradient, _path, _path2, _g, _path3, _path4, _linearGradient2, _path5, _linearGradient3, _path6, _linearGradient4, _path7, _linearGradient5, _path8, _linearGradient6, _path9, _g2, _linearGradient7, _linearGradient8, _path10, _linearGradient9, _path11, _linearGradient10, _path12, _linearGradient11, _path13, _linearGradient12, _path14, _linearGradient13, _path15, _linearGradient14, _linearGradient15, _path16, _linearGradient16, _path17, _linearGradient17, _path18, _linearGradient18, _path19, _linearGradient19, _linearGradient20, _path20, _linearGradient21, _path21, _g3, _linearGradient22, _path22, _linearGradient23, _path23, _linearGradient24, _path24, _linearGradient25, _linearGradient26, _path25, _linearGradient27, _path26, _linearGradient28, _linearGradient29, _path27, _linearGradient30, _path28, _linearGradient31, _g4, _linearGradient32, _path29, _linearGradient33, _path30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaitingImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 696,
    viewBox: "0 0 700 696",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1",
    x1: 641.493459,
    y1: 423.58513,
    x2: 699.10911,
    y2: -70.253982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#e38ddd",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571f6",
    stopOpacity: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Percorso",
    fill: "url(#linearGradient1)",
    stroke: "none",
    d: "M 425.575195 547.901367 C 411.744598 545.300781 388.46106 540.922485 369.697083 521.748169 C 335.583496 486.888031 338.552948 425.751709 354.90097 385.201172 C 368.943176 350.369904 399.488708 325.284943 460.579803 275.114319 C 518.11554 227.863464 538.812317 220.813202 541.278076 195.707825 C 544.793457 159.917175 506.28598 138.033569 516.551331 96.937073 C 517.783508 92.005554 522.014343 75.067688 535.895691 67.281006 C 559.657959 53.951843 595.022034 76.793762 612.405212 94.643494 C 629.172485 111.86084 648.883545 144.634705 640.34613 173.94397 C 634.160583 195.179138 618.401123 196.555939 617.240601 215.567078 C 616.072937 234.694794 631.673828 239.070313 642.158936 269.121246 C 646.347656 281.126678 654.755798 305.22467 646.511414 327.741669 C 635.851196 356.856323 607.000244 356.971771 604.475525 380.453644 C 602.651245 397.419769 617.117371 402.90683 619.042725 422.086884 C 621.577332 447.336792 599.594482 468.592834 581.067139 486.031891 C 559.250549 506.567627 500.39151 561.969727 425.575195 547.901367 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.16,
    style: {
      mixBlendMode: "screen"
    },
    d: "M 546.701721 76.883484 C 534.579773 88.413391 579.865906 125.29657 577.032166 183.089783 C 573.983276 245.272675 517.087036 293.727997 490.793457 316.120605 C 445.93277 354.326202 423.950897 350.814148 397.265137 390.389465 C 386.703217 406.052643 364.699677 438.68396 373.462341 478.242554 C 374.276276 481.917725 383.953735 522.758301 418.185608 537.766846 C 457.013855 554.791199 497.911346 525.637024 533.151184 500.517151 C 554.444824 485.337982 596.981995 455.016296 589.869446 429.538452 C 585.521423 413.963623 563.620667 403.785706 546.628418 402.394897 C 522.375488 400.408844 504.799866 416.051331 502.076019 412.213013 C 499.622742 408.755798 511.522034 392.739502 529.127197 379.592926 C 564.341064 353.297516 586.38147 365.368988 611.963379 341.94928 C 615.064392 339.110748 639.310303 316.25415 635.628906 287.319397 C 633.505859 270.631165 622.03717 251.486938 608.317749 250.018097 C 592.801025 248.356964 581.101929 270.021454 577.152405 267.262756 C 573.375793 264.625275 581.777954 243.214783 593.129944 223.302063 C 609.809937 194.043976 618.959534 192.399323 624.130188 174.659729 C 632.019104 147.594421 619.182495 122.390991 617.286377 118.794312 C 599.517151 85.094116 557.065674 67.025452 546.701721 76.883484 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    fill: "#d8dee8",
    stroke: "none",
    d: "M 262.619629 589.000122 C 275.722809 586.536316 297.781525 582.388428 315.558472 564.222412 C 347.877686 531.196167 345.064392 473.275665 329.576202 434.858002 C 316.272766 401.858856 287.333984 378.093567 229.456375 330.561829 C 174.947174 285.796631 155.338943 279.117188 153.002945 255.332397 C 149.672409 221.4245 186.154373 200.691925 176.429062 161.757019 C 175.261765 157.085022 171.253494 141.038208 158.102325 133.661194 C 135.589951 121.032776 102.085968 142.673462 85.617241 159.584229 C 69.731949 175.895813 51.057686 206.945648 59.146049 234.713348 C 65.006248 254.831451 79.936722 256.135803 81.036217 274.147125 C 82.142387 292.268555 67.362221 296.413727 57.428688 324.884064 C 53.460129 336.257996 45.494301 359.088623 53.305111 380.421082 C 63.404552 408.004059 90.737984 408.113525 93.129753 430.360168 C 94.858116 446.433868 81.153015 451.632507 79.32885 469.803528 C 76.927559 493.725342 97.754143 513.863159 115.306877 530.384766 C 135.975922 549.840393 191.738861 602.32843 262.619629 589.000122 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.16,
    style: {
      mixBlendMode: "screen"
    },
    d: "M 147.864655 142.758301 C 159.348923 153.682007 116.444824 188.624786 119.129623 243.378174 C 122.018188 302.289978 175.921494 348.196594 200.832077 369.411133 C 243.332993 405.607239 264.158539 402.279694 289.440643 439.773499 C 299.446899 454.61261 320.293091 485.527527 311.991333 523.005249 C 311.220215 526.487183 302.051849 565.179321 269.620514 579.398438 C 232.834732 595.527405 194.088516 567.906799 160.702347 544.108215 C 140.528717 529.727539 100.229202 501.000671 106.967705 476.86319 C 111.086929 462.107605 131.835709 452.465027 147.934067 451.1474 C 170.91124 449.265991 187.5625 464.085602 190.142883 460.448975 C 192.467087 457.173767 181.193802 441.999817 164.514755 429.544647 C 131.153152 404.632446 110.272072 416.069244 86.035797 393.881348 C 83.098007 391.192169 60.127377 369.537781 63.615208 342.124817 C 65.626511 326.314575 76.491913 308.177277 89.489784 306.78598 C 104.190201 305.212067 115.273949 325.737 119.015686 323.123566 C 122.593575 320.624634 114.633377 300.340424 103.878586 281.475006 C 88.076012 253.75592 79.407677 252.197876 74.508949 235.391449 C 67.035103 209.749786 79.196442 185.87204 80.992851 182.464661 C 97.827461 150.536865 138.045853 133.418884 147.864655 142.758301 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2",
    x1: 162.37008,
    y1: 972.049126,
    x2: 167.045258,
    y2: 378.251505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#135cfa",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083ba7",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    fill: "url(#linearGradient2)",
    stroke: "none",
    d: "M 545.586853 594.359192 L 448.144257 597.384521 C 421.233063 595.82959 390.281708 596.316284 357.270599 597.271362 C 324.160583 598.228943 292.943726 599.688843 265.688416 602.831177 L 165.72374 605.783997 L 165.72374 626.081543 L 165.73613 626.081543 C 165.73439 626.081543 165.723846 626.101501 165.723846 626.141235 C 165.723846 639.107422 252.055603 646.92157 357.634308 643.64679 C 462.213654 640.403015 546.102966 626.798889 545.904114 614.060059 C 545.903564 614.021057 545.887878 613.284241 545.886536 613.284241 L 545.888184 613.284241 L 545.586853 594.359192 Z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3",
    x1: 558.368299,
    y1: 573.559467,
    x2: 457.148879,
    y2: 856.512658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#135cfa",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05112b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    fill: "url(#linearGradient3)",
    stroke: "none",
    d: "M 545.594727 594.598938 C 545.793274 607.317139 461.968262 620.164673 357.474701 623.309814 C 251.983444 626.484985 165.723846 618.577454 165.723846 605.633057 C 165.723846 592.702148 251.818466 579.819458 357.109406 576.87146 C 461.406494 573.951477 545.396606 581.894104 545.594727 594.598938 Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path6",
    fill: "#d8dee8",
    stroke: "none",
    opacity: 0.5,
    d: "M 422.812714 294.980438 L 374.512054 332.970123 L 423.803558 369.64975 C 478.832855 410.528473 511.552765 475.265381 512.54834 545.024719 L 513.230652 592.826782 C 513.243408 593.720337 512.445801 594.483093 511.093964 595.381897 L 362.238495 591.880432 L 352.210663 592.165894 L 201.07634 604.384949 C 199.672104 603.554016 199.218185 602.815796 199.216919 601.908936 L 199.150284 553.406128 C 199.052979 482.628845 231.517365 415.617188 286.842804 372.206268 L 335.638123 333.834778 L 286.373749 297.066986 C 230.990158 255.947174 198.652313 191.277435 198.557892 122.590393 L 198.490097 73.323669 L 348.528015 79.688049 L 358.422729 79.634094 L 505.793091 71.734802 L 506.486572 120.31665 C 507.453217 188.044006 476.596039 252.656067 422.812714 294.980438 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path7",
    fill: "#bfc8d6",
    stroke: "none",
    d: "M 513.038452 592.813904 C 513.05127 593.707458 512.35144 594.601929 510.999664 595.500793 C 498.956848 603.438599 434.876282 611.131836 357.052704 613.439331 C 278.677124 615.763184 213.209549 611.83606 200.715942 604.511841 C 199.311707 603.680908 198.577744 602.815369 198.576477 601.908752 C 198.564453 592.951843 269.680634 583.695435 356.799927 581.239197 C 443.23761 578.802246 512.912537 583.98645 513.038452 592.813904 Z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4",
    x1: 362.698026,
    y1: 240.587886,
    x2: 354.468722,
    y2: 913.362495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#f36f56",
    stopOpacity: 1
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path8",
    fill: "url(#linearGradient4)",
    stroke: "none",
    d: "M 359.681396 448.787079 L 351.648926 448.965576 L 350.649689 318.881836 L 358.639252 318.751465 L 359.681396 448.787079 Z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5",
    x1: 447.426553,
    y1: 188.836398,
    x2: 441.91925,
    y2: 639.077756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#f36f56",
    stopOpacity: 1
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path9",
    fill: "url(#linearGradient5)",
    stroke: "none",
    d: "M 354.478058 242.346008 L 261.869934 243.536499 L 266.689514 251.552368 C 266.689514 251.552368 301.103119 300.803253 355.145905 327.250824 C 408.498718 299.142578 441.700531 249.261993 441.700531 249.261993 L 446.316406 241.165344 L 354.478058 242.346008 Z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient6",
    x1: 475.114771,
    y1: -82.60232,
    x2: 428.742453,
    y2: 453.578827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#f36f56",
    stopOpacity: 1
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path10",
    fill: "url(#linearGradient6)",
    stroke: "none",
    d: "M 446.298492 239.629547 C 446.355225 244.476868 405.366028 248.949005 354.535309 249.619293 C 303.469604 250.292572 261.883362 246.875946 261.863739 241.987579 C 261.844208 237.100983 303.368317 232.626587 354.396698 231.994415 C 405.19046 231.365143 446.241821 234.783844 446.298492 239.629547 Z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7",
    x1: 355.946048,
    y1: 438.330893,
    x2: 355.944586,
    y2: 438.450389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#f36f56",
    stopOpacity: 1
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path11",
    fill: "url(#linearGradient7)",
    stroke: "none",
    d: "M 355.441254 438.361786 C 355.406372 438.351257 355.44101 438.338593 355.44101 438.338593 C 355.44101 438.338593 355.4758 438.349609 355.441254 438.361786 Z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient8",
    x1: 489.063703,
    y1: 338.299142,
    x2: 478.359995,
    y2: 1213.365355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#f36f56",
    stopOpacity: 1
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path12",
    fill: "url(#linearGradient8)",
    stroke: "none",
    d: "M 485.471558 593.546631 C 439.687103 603.780518 368.308777 606.928345 357.920685 607.233337 C 357.920685 607.233337 357.239502 607.25354 356.765869 607.267334 C 356.292145 607.281311 355.61084 607.30127 355.61084 607.30127 C 350.088196 607.463501 327.23941 607.841187 299.996368 607.018799 C 275.971069 606.275085 248.576279 604.627258 226.646866 601.057617 C 226.600052 601.059021 226.757126 600.891235 226.757126 600.879089 C 226.757126 600.879089 226.757126 600.867615 226.757126 600.843994 C 226.757126 600.549377 226.757126 598.475159 226.757126 595.153381 C 226.757126 595.153381 226.757126 595.141235 226.757126 595.1297 C 227.741547 578.194397 230.241272 529.250244 238.776077 518.684082 C 248.938736 506.108215 352.084015 440.690918 355.50827 438.395996 C 358.966492 440.540833 462.080444 500.847839 472.230682 512.793152 C 474.958862 516.000671 477.152374 523.182861 478.927521 531.908691 C 480.947113 541.816528 482.399445 553.836121 483.41861 564.623047 C 484.91394 580.40741 485.471558 593.546631 485.471558 593.546631 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13",
    fill: "#ffffff",
    stroke: "none",
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M 266.582794 145.657227 C 265.490509 115.119568 268.134583 92.94751 268.134583 92.94751 C 268.134583 92.94751 259.831299 73.67041 230.617142 82.563965 C 222.978546 105.11145 219.98465 126.769043 220.392197 146.047302 L 266.582794 145.657227 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    fill: "#ffffff",
    stroke: "none",
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M 267.290009 159.251953 L 221.210495 159.669312 C 231.522629 261.097626 330.563629 319.198944 330.563629 319.198944 L 354.059052 318.815491 C 289.176849 293.492767 271.245148 216.042786 267.290009 159.251953 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path15",
    fill: "#ffffff",
    stroke: "none",
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M 270.246399 586.287109 L 228.583115 587.466797 C 223.1875 568.795288 221.00235 550.058594 221.27771 533.628113 L 268.216614 532.413086 C 267.382385 562.889404 270.123627 585.115906 270.246399 586.287109 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    fill: "#ffffff",
    stroke: "none",
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M 268.815308 518.368591 L 222.045532 519.549194 C 231.94281 414.422791 330.791473 352.479218 330.791473 352.479218 L 354.319153 352.059967 C 289.625488 380.879791 272.319061 460.00885 268.815308 518.368591 Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g7"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient9",
    x1: 184.002934,
    y1: 370.159147,
    x2: 160.695468,
    y2: 40.942667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#135cfa",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083ba7",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    fill: "url(#linearGradient9)",
    stroke: "none",
    d: "M 537.431152 71.81604 L 442.054382 72.390442 C 415.717285 70.290527 385.427582 69.999817 353.123932 70.163452 C 320.725647 70.327698 290.181824 70.988831 263.51535 73.376465 L 165.72374 73.903564 L 165.72374 92.532104 L 165.735886 92.532104 C 165.734177 92.532104 165.723846 92.870178 165.723846 92.907776 C 165.723846 105.31366 250.173965 114.914673 353.471252 114.185181 C 455.811676 113.462341 537.927856 102.92804 537.73761 90.730835 C 537.736938 90.693665 537.725891 90.563293 537.724548 90.563293 L 537.726135 90.563293 L 537.431152 71.81604 Z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient10",
    x1: 549.479132,
    y1: 52.121617,
    x2: 456.182511,
    y2: 312.927072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#135cfa",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05112b",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    fill: "url(#linearGradient10)",
    stroke: "none",
    d: "M 537.436646 71.681824 C 537.626648 83.859314 455.576233 94.248352 353.318207 94.880554 C 250.104904 95.518494 165.723846 85.990662 165.723846 73.605469 C 165.723846 61.233154 249.946899 50.861572 352.968506 50.432007 C 455.038452 50.006348 537.246887 59.516724 537.436646 71.681824 Z"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient11",
    x1: 487.263096,
    y1: 485.506223,
    x2: 482.370023,
    y2: 885.532093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#f36f56",
    stopOpacity: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    fill: "url(#linearGradient11)",
    stroke: "none",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M 485.471558 593.546631 C 439.687103 603.780518 368.308777 606.928345 357.920685 607.233337 C 357.920685 607.233337 357.239502 607.25354 356.765869 607.267334 C 356.292145 607.281311 355.61084 607.30127 355.61084 607.30127 C 350.088196 607.463501 327.23941 607.841187 299.996368 607.018799 C 275.971069 606.275085 248.576279 604.627258 226.646866 601.057617 C 226.600052 601.059021 226.757126 600.891235 226.757126 600.879089 C 226.757126 600.879089 226.757126 600.867615 226.757126 600.843994 C 226.757126 600.549377 226.593613 598.477905 226.737045 595.151733 C 252.517761 595.177673 306.158539 593.28595 329.423157 578.180847 C 360.445862 558.029724 386.317932 556.732544 420.24173 562.218689 C 448.086761 566.727295 468.217346 551.153381 478.919037 531.908936 C 480.93808 541.816711 482.389679 553.836365 483.419983 564.623047 C 484.915222 580.40741 485.471558 593.546631 485.471558 593.546631 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8"
  }, _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient12",
    x1: 91.120061,
    y1: 456.843061,
    x2: 88.242012,
    y2: 385.210851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#f36f56",
    stopOpacity: 1
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path20",
    fill: "url(#linearGradient12)",
    stroke: "none",
    d: "M 86.868317 422.95401 C 86.868317 422.95401 89.426559 432.086243 89.74633 437.202728 C 90.0662 442.319458 84.310066 451.273376 83.030777 451.593262 C 81.751709 451.913147 82.07148 448.395386 83.030777 443.918396 C 83.990189 439.441223 81.663254 431.126831 82.187134 425.050903 L 86.868317 422.95401 Z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient13",
    x1: 173.852996,
    y1: 553.063034,
    x2: 140.803984,
    y2: 672.326899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976",
    stopOpacity: 1
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path21",
    fill: "url(#linearGradient13)",
    stroke: "none",
    d: "M 154.584686 624.356384 C 154.584686 624.356384 153.008667 630.744141 152.958771 633.05835 C 152.908417 635.372803 178.376709 638.598938 178.773102 636.893738 C 179.169769 635.188538 174.906082 632.085388 171.828094 630.864197 C 168.749847 629.6427 159.720917 626.317932 159.720917 626.317932 L 154.584686 624.356384 Z"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient14",
    x1: 162.045741,
    y1: 641.017306,
    x2: 161.56674,
    y2: 600.783511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#f36f56",
    stopOpacity: 1
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path22",
    fill: "url(#linearGradient14)",
    stroke: "none",
    d: "M 161.306549 618.400757 L 159.846313 626.383545 C 159.846313 626.383545 156.719666 628.108032 154.224869 626.383545 L 153.617691 617.518433 L 161.306549 618.400757 Z"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient15",
    x1: 132.47653,
    y1: 541.596449,
    x2: 99.427189,
    y2: 660.861489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976",
    stopOpacity: 1
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path23",
    fill: "url(#linearGradient15)",
    stroke: "none",
    d: "M 108.135933 631.194397 C 108.135933 631.194397 106.559601 637.581909 106.509453 639.896362 C 106.459312 642.210754 131.927856 645.436646 132.324142 643.731445 C 132.720657 642.026733 128.457001 638.923401 125.379005 637.701904 C 122.301003 636.480652 113.272049 633.155396 113.272049 633.155396 L 108.135933 631.194397 Z"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient16",
    x1: 115.522168,
    y1: 641.571382,
    x2: 115.043162,
    y2: 601.337164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#f36f56",
    stopOpacity: 1
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path24",
    fill: "url(#linearGradient16)",
    stroke: "none",
    d: "M 114.857689 625.238708 L 113.397232 633.221497 C 113.397232 633.221497 110.270813 634.945984 107.775894 633.221497 L 107.168953 624.356384 L 114.857689 625.238708 Z"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient17",
    x1: 180.92875,
    y1: 401.392467,
    x2: 138.091359,
    y2: 401.392467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#26264f",
    stopOpacity: 1
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path25",
    fill: "url(#linearGradient17)",
    stroke: "none",
    d: "M 173.504364 407.92099 C 175.979095 414.148132 178.453934 420.375244 180.928757 426.602142 C 180.565613 460.978577 178.76796 498.246338 174.8237 537.939819 C 171.889465 567.471924 168.063293 595.363525 163.685471 621.482056 C 159.693924 620.977417 155.702667 620.47168 151.710907 619.967529 C 146.839142 608.005981 141.39624 590.03894 142.490005 568.486633 C 143.630585 546.005249 150.669006 543.572388 151.958618 522.063049 C 153.629974 494.184509 142.553452 485.823059 139.018127 451.844971 C 137.666092 438.850555 137.405182 421.998962 140.933975 401.862518 C 151.790985 403.881409 162.647461 405.9021 173.504364 407.92099 Z"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient18",
    x1: 180.928515,
    y1: 401.392467,
    x2: 138.091289,
    y2: 401.392467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#26264f",
    stopOpacity: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    fill: "url(#linearGradient18)",
    stroke: "none",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M 140.933975 401.862518 C 146.797394 402.952728 152.660583 404.043182 158.524094 405.13501 C 167.683395 424.509613 169.110245 444.026245 166.559006 452.403748 C 162.94989 464.256805 155.650208 467.561401 155.063828 479.705414 C 154.48349 491.721375 161.295883 495.395203 164.6436 509.88092 C 166.960571 519.910156 165.421646 528.837463 162.248291 546.282898 C 155.856735 581.423279 146.434357 591.57135 152.668961 603.760071 C 154.440811 607.223267 157.794159 611.447571 164.741135 615.024048 C 164.391205 617.182495 164.043304 619.347778 163.685471 621.482056 C 159.693924 620.978394 155.702667 620.47168 151.710907 619.968018 C 146.839142 608.004822 141.39624 590.039185 142.490005 568.486633 C 143.630585 546.005005 150.669006 543.571716 151.958618 522.062805 C 153.629974 494.184265 142.553452 485.823547 139.018127 451.845215 C 137.666092 438.850769 137.405182 421.999207 140.933975 401.862518 Z"
  }), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient19",
    x1: 156.743855,
    y1: 397.710467,
    x2: 91.717208,
    y2: 397.710467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#26264f",
    stopOpacity: 1
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "path27",
    fill: "url(#linearGradient19)",
    stroke: "none",
    d: "M 156.743866 417.43161 C 148.773712 447.232422 141.280701 479.209961 134.707184 513.233276 C 126.770393 554.31366 121.175797 593.193665 117.299934 629.397827 C 112.892845 629.170654 108.485649 628.94165 104.078568 628.714294 C 89.498047 593.047729 90.301643 569.722778 94.012405 554.792358 C 95.442345 549.038818 98.97332 537.815674 100.939423 520.7771 C 102.309578 508.899963 102.276184 499.774841 102.200119 488.80249 C 102.033867 464.745117 99.9263 459.327332 101.027878 441.024567 C 102.061058 423.847351 102.686134 415.163971 107.987579 410.491058 C 121.954964 398.18045 154.29303 416.046509 156.743866 417.43161 Z"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient20",
    x1: 301.28963,
    y1: 330.642056,
    x2: 261.054871,
    y2: 371.595257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#f36f56",
    stopOpacity: 1
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "path28",
    fill: "url(#linearGradient20)",
    stroke: "none",
    d: "M 284.699677 348.198883 C 284.699677 348.198883 294.38205 347.368927 295.782715 345.799103 C 297.183411 344.229523 299.311188 341.715454 299.521149 340.276459 C 299.73111 338.836975 301.601624 340.986877 299.905975 344.10791 C 298.210175 347.228699 303.021454 346.567841 303.772308 346.49234 C 305.49884 346.318848 312.084625 346.125885 311.894836 346.533417 C 311.704742 346.94165 312.67688 348.743195 307.999603 350.862366 C 303.90506 352.717621 299.030853 351.510132 296.369019 351.637756 C 293.70752 351.765106 293.70752 351.765106 293.70752 351.765106 L 286.648224 352.303436 L 284.699677 348.198883 Z"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient21",
    x1: 84.224112,
    y1: 248.10065,
    x2: 276.773511,
    y2: 444.960542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#6165d7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa80f9",
    stopOpacity: 1
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path29",
    fill: "url(#linearGradient21)",
    stroke: "none",
    d: "M 290.375366 343.67514 C 290.801849 346.902618 291.228088 350.130127 291.654694 353.357605 C 285.241791 358.706787 271.06366 368.960663 251.338394 370.498352 C 216.564636 373.210907 182.080002 347.475159 175.659668 318.5289 C 172.480591 304.193237 175.077606 284.08017 183.986893 280.845795 C 186.459778 279.947601 190.175018 280.075226 197.834595 285.220825 C 218.275696 298.951904 220.014145 316.98526 231.306717 329.183624 C 239.433975 337.962494 255.413452 346.856262 290.375366 343.67514 Z"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient22",
    x1: 89.362619,
    y1: 569.609288,
    x2: 234.492852,
    y2: 361.253931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#6165d7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa80f9",
    stopOpacity: 1
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "path30",
    fill: "url(#linearGradient22)",
    stroke: "none",
    d: "M 183.802628 433.005066 C 188.575836 426.352264 183.824432 419.185913 183.681244 405.844971 C 183.519135 390.724731 189.501755 388.68866 197.214005 364.270508 C 202.342773 348.030914 207.266388 332.440491 204.398605 313.499603 C 203.024292 304.421783 200.693344 289.025269 188.770874 280.72348 C 182.618347 276.43927 173.775391 276.109772 156.34082 275.626923 C 134.78096 275.029388 124.001373 274.730194 115.657738 278.304413 C 114.436386 278.82782 89.01902 290.123962 85.61219 311.583984 C 82.144447 333.425629 105.843307 338.297729 106.686951 367.862885 C 107.065804 381.134949 102.889565 401.166534 100.181358 414.159149 C 97.580666 426.634247 96.2276 429.773407 98.408821 433.788208 C 103.666084 443.46521 122.227684 442.314178 159.350998 440.014191 C 173.912933 439.111938 180.240799 437.969879 183.802628 433.005066 Z"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient23",
    x1: 89.307728,
    y1: 569.570916,
    x2: 234.438408,
    y2: 361.214925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa80f9",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#6165d7",
    stopOpacity: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    fill: "url(#linearGradient23)",
    stroke: "none",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M 133.030792 365.229034 C 131.021088 370.817078 125.097664 374.636383 120.098671 388.219849 C 119.019478 391.152924 111.332802 412.037476 118.661499 417.917389 C 122.895096 421.312866 127.37458 415.880859 138.299423 416.000183 C 157.230682 416.206482 164.931351 432.748291 177.575729 429.412933 C 179.769485 428.833038 182.714722 427.460815 185.821518 424.013031 C 186.116257 427.367889 185.789841 430.23465 183.802628 433.005066 C 180.240799 437.969879 173.912933 439.111938 159.350998 440.014191 C 122.227684 442.314178 103.666084 443.46521 98.408821 433.788208 C 96.2276 429.773407 97.580666 426.634247 100.181358 414.159149 C 102.889565 401.166534 107.065804 381.134949 106.686951 367.862885 C 105.843307 338.297729 82.144447 333.425629 85.61219 311.583984 C 86.539139 305.745117 89.119766 300.686432 92.374786 296.36438 C 121.753952 311.084412 139.347534 347.668823 133.030792 365.229034 Z"
  }), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient24",
    x1: 183.646802,
    y1: 282.271467,
    x2: 160.320068,
    y2: 247.957666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#f36f56",
    stopOpacity: 1
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "path32",
    fill: "url(#linearGradient24)",
    stroke: "none",
    d: "M 156.951889 253.884186 C 156.951889 253.884186 155.949692 261.855988 152.98584 267.648529 C 150.307602 272.883636 138.229904 275.341705 135.740372 276.358734 C 133.250397 277.375488 139.843292 281.459869 146.692978 282.707489 C 153.542191 283.955109 173.387558 283.967499 177.152008 281.634491 C 180.916595 279.301941 174.489594 278.984985 169.705841 276.780487 C 164.92218 274.576416 162.844925 264.708984 164.065338 260.403717 C 165.28566 256.098114 156.951889 253.884186 156.951889 253.884186 Z"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient25",
    x1: 158.930107,
    y1: 284.277656,
    x2: 176.283977,
    y2: 240.201959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#3e4177",
    stopOpacity: 1
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "path33",
    fill: "url(#linearGradient25)",
    stroke: "none",
    d: "M 168.105499 251.858673 C 171.970596 248.625458 172.503525 248.254364 172.991501 247.068726 C 174.948761 242.310425 171.696823 235.318726 166.860275 233.274139 C 166.608673 233.167908 163.362244 231.834198 161.974655 233.177979 C 160.795959 234.318909 162.249191 236.141846 161.304153 238.447083 C 160.418961 240.605255 158.485443 240.617371 154.694153 243.23703 C 151.570831 245.394073 149.629837 246.735077 149.041946 248.793427 C 147.829758 253.03656 152.5495 259.70517 157.184814 259.905518 C 158.851791 259.97757 159.371887 259.164795 168.105499 251.858673 Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient26",
    x1: 188.68408,
    y1: 259.692901,
    x2: 151.434755,
    y2: 239.404329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#f36f56",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    fill: "url(#linearGradient26)",
    stroke: "none",
    d: "M 157.58374 260.60791 C 157.58374 260.60791 161.046677 265.225555 166.962738 264.264771 C 172.259613 263.404694 171.889465 251.376129 168.240677 249.166779 C 167.023315 248.430176 164.714752 248.298004 162.914886 248.994232 C 161.851547 249.40567 161.525925 249.895111 159.775879 250.533722 C 158.161667 251.12207 157.675873 250.983734 157.216919 251.452728 C 156.642349 252.038818 156.308792 253.372498 157.689056 256.766815 C 156.572815 255.834717 155.314148 255.557526 154.488754 256.048553 C 154.35704 256.127319 154.014679 256.411591 153.845337 256.808563 C 153.23172 258.245972 154.646393 259.869507 157.58374 260.60791 Z"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient27",
    x1: 5.747696,
    y1: 549.02361,
    x2: 167.45325,
    y2: 316.871965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#6165d7",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa80f9",
    stopOpacity: 1
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "path35",
    fill: "url(#linearGradient27)",
    stroke: "none",
    d: "M 118.513023 277.263306 C 115.657738 278.304413 86.868317 284.024658 76.635101 331.673157 C 66.402 379.321472 80.152756 427.609283 80.152756 427.609283 L 89.74633 427.609283 C 89.74633 427.609283 91.984924 354.697723 131.958252 330.39386 L 118.513023 277.263306 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient28",
    x1: 525.423428,
    y1: 653.468328,
    x2: 523.926961,
    y2: 558.764687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976",
    stopOpacity: 1
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "path36",
    fill: "url(#linearGradient28)",
    stroke: "none",
    d: "M 529.396484 635.385864 C 529.396484 635.385864 537.423706 637.689514 543.549927 640.243774 C 549.676025 642.797729 549.440918 638.867615 548.511597 634.183716 C 547.582092 629.499939 539.131531 632.227417 539.131531 632.227417 C 539.131531 632.227417 525.539124 631.047058 529.396484 635.385864 Z"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient29",
    x1: 528.566084,
    y1: 518.792938,
    x2: 538.603867,
    y2: 644.594952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#f36f56",
    stopOpacity: 1
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "path37",
    fill: "url(#linearGradient29)",
    stroke: "none",
    d: "M 561.502441 503.917908 C 561.161377 516.430054 559.600708 527.138672 557.751404 535.880554 C 555.762146 545.284912 554.603271 546.90979 553.982727 553.412781 C 552.632935 567.563232 557.193359 569.588989 558.030579 585.583557 C 558.955383 603.24469 554.259338 617.281372 552.413147 622.635803 C 550.799133 627.317017 549.10968 631.096863 547.83905 633.722473 C 546.75293 634.669495 545.281677 634.737366 543.642822 634.519409 C 542.187317 634.3255 541.076294 633.10083 540.985779 631.635437 C 540.050903 616.513367 538.924194 602.155884 538.011108 586.947754 C 534.909729 562.849243 531.808533 538.751709 528.707275 514.653198 C 539.639038 511.074402 550.570557 507.496521 561.502441 503.917908 Z"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient30",
    x1: 528.566084,
    y1: 518.792915,
    x2: 538.603867,
    y2: 644.594882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#f36f56",
    stopOpacity: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    fill: "url(#linearGradient30)",
    stroke: "none",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M 540.977173 631.495239 C 540.044006 616.424561 538.92157 602.108826 538.011108 586.947754 C 534.909729 562.849243 531.808533 538.751709 528.707275 514.653198 C 539.639038 511.074402 550.570557 507.496521 561.502441 503.917908 C 561.479858 504.746338 561.438232 505.545319 561.405518 506.358582 C 546.068176 519.677917 543.066589 530.228943 543.216431 537.425781 C 543.398071 546.154419 548.171143 550.481323 547.238647 563.137024 C 546.571838 572.185913 543.851563 573.780273 543.852722 581.945984 C 543.854248 592.46051 548.367249 598.37262 550.564941 604.448242 C 552.689148 610.321106 553.445251 618.638672 549.341553 630.469238 C 548.802612 631.690979 548.293457 632.78418 547.83905 633.722473 C 546.783691 634.642395 545.364136 634.732788 543.780823 634.537292 C 542.242493 634.346863 541.072937 633.042297 540.977173 631.495239 Z"
  }), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient31",
    x1: 502.778292,
    y1: 658.149076,
    x2: 501.281823,
    y2: 563.44527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976",
    stopOpacity: 1
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "path39",
    fill: "url(#linearGradient31)",
    stroke: "none",
    d: "M 506.751343 640.066589 C 506.751343 640.066589 514.778687 642.370483 520.904846 644.9245 C 527.031006 647.478455 526.796021 643.54834 525.866455 638.864624 C 524.937195 634.180725 516.486511 636.907959 516.486511 636.907959 C 516.486511 636.907959 502.893951 635.728027 506.751343 640.066589 Z"
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient32",
    x1: 505.921019,
    y1: 523.47378,
    x2: 515.958802,
    y2: 649.275723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#f36f56",
    stopOpacity: 1
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "path40",
    fill: "url(#linearGradient32)",
    stroke: "none",
    d: "M 538.857422 508.598663 C 538.516174 521.110962 536.955688 531.819458 535.106262 540.561523 C 533.117004 549.965698 531.958313 551.590576 531.337646 558.093506 C 529.987976 572.244202 534.548218 574.269775 535.38562 590.264282 C 536.310425 607.925415 531.614197 621.962341 529.768066 627.316528 C 528.154053 631.997498 526.464539 635.777832 525.19397 638.403381 C 524.10791 639.35022 522.636536 639.418091 520.99762 639.200134 C 519.542114 639.006226 518.431335 637.781738 518.340759 636.316162 C 517.405823 621.194092 516.279297 606.836609 515.366028 591.628479 C 512.264832 567.529968 509.163544 543.432434 506.062134 519.334167 C 516.993958 515.755371 527.92572 512.17749 538.857422 508.598663 Z"
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient33",
    x1: 505.921019,
    y1: 523.47378,
    x2: 515.958802,
    y2: 649.275653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#f36f56",
    stopOpacity: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path41",
    fill: "url(#linearGradient33)",
    stroke: "none",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M 518.332031 636.175964 C 517.398865 621.105469 516.276428 606.789795 515.366028 591.628479 C 512.264832 567.529968 509.163544 543.432434 506.062134 519.334167 C 516.993958 515.755371 527.92572 512.17749 538.857422 508.598663 C 538.834961 509.427246 538.793152 510.226288 538.760315 511.03952 C 523.423279 524.358643 520.421448 534.909668 520.571411 542.106567 C 520.753052 550.835327 525.526123 555.161987 524.593689 567.817993 C 523.92688 576.866882 521.206604 578.46106 521.207642 586.626709 C 521.209229 597.141479 525.721985 603.053345 527.920044 609.129211 C 530.044067 615.002075 530.800171 623.319397 526.696533 635.149963 C 526.157715 636.371704 525.648315 637.464661 525.19397 638.403381 C 524.138489 639.323364 522.719177 639.413513 521.135925 639.218018 C 519.597412 639.027771 518.427856 637.723022 518.332031 636.175964 Z"
  }), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient34",
    x1: 599.478019,
    y1: 367.816917,
    x2: 617.69919,
    y2: 483.252509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9085",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb6fbb",
    stopOpacity: 1
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "path42",
    fill: "url(#linearGradient34)",
    stroke: "none",
    d: "M 520.111694 405.975769 C 507.253784 408.12912 497.477936 410.446777 493.23468 417.753326 C 488.753021 425.471527 496.232788 431.510529 498.567535 448.701935 C 502.142303 475.020996 488.544617 484.536438 493.023193 511.055817 C 493.753845 515.38385 494.810913 519.244934 495.932098 522.546082 C 497.903595 528.351196 501.605469 533.280701 506.396576 536.635071 C 509.989319 539.150513 514.347046 541.697388 519.442566 543.741943 C 532.625 549.030334 539.023804 546.254211 556.650757 547.728088 C 585.482483 550.140076 589.970947 559.375305 602.872314 554.02771 C 615.911255 548.623718 625.130859 533.469543 622.215271 526.848145 C 620.468994 522.882935 615.247864 525.224915 607.598328 520.240845 C 598.267334 514.161011 598.963135 507.187866 591.1698 497.917297 C 579.832397 484.432251 570.303162 490.731201 560.579529 478.81897 C 553.758179 470.462585 552.876221 460.537079 551.337646 443.224731 C 549.69989 424.797821 552.412354 411.281342 545.055664 407.243134 C 543.28772 406.272705 541.167297 405.755249 538.63678 405.833954 C 528.660828 406.142822 521.168945 405.798401 520.111694 405.975769 Z"
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient35",
    x1: 534.900625,
    y1: 404.706351,
    x2: 525.431746,
    y2: 420.023673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#f36f56",
    stopOpacity: 1
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "path43",
    fill: "url(#linearGradient35)",
    stroke: "none",
    d: "M 520.894958 397.278656 L 515.318359 409.966248 C 515.318359 409.966248 523.556519 414.098785 531.096497 409.966248 L 531.096497 397.278656 L 520.894958 397.278656 Z"
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient36",
    x1: 517.68377,
    y1: 392.390934,
    x2: 603.561665,
    y2: 511.463363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9085",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb6fbb",
    stopOpacity: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    fill: "url(#linearGradient36)",
    stroke: "none",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M 601.169006 544.039612 C 597.125488 541.046387 599.125305 532.845825 593.135681 528.342957 C 587.576294 524.164063 583.404541 529.387024 575.274719 526.505127 C 564.847534 522.808105 565.177856 511.899597 555.182251 508.203735 C 547.994446 505.546265 545.937256 510.489929 535.643921 510.487183 C 525.368286 510.485107 511.801971 505.554749 503.037537 493.443054 C 499.313446 488.296753 497.182678 482.845459 495.983459 477.822144 C 493.422485 487.486511 490.619476 496.822021 493.023193 511.05603 C 493.99585 516.816406 495.54657 521.750732 497.057159 525.637695 C 498.466492 529.263794 500.787079 532.402039 503.743011 534.683228 C 507.766907 537.788391 513.018188 541.164124 519.442566 543.741516 C 532.624878 549.030334 539.023804 546.253967 556.650757 547.728333 C 585.482483 550.139832 589.970947 559.375305 602.872314 554.027954 C 611.205627 550.574219 617.960205 543.141479 621.00238 536.495789 C 609.79657 545.318665 604.10321 546.211975 601.169006 544.039612 Z"
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g11"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient37",
    x1: 504.393291,
    y1: 391.152956,
    x2: 521.258244,
    y2: 416.401922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#f36f56",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    fill: "url(#linearGradient37)",
    stroke: "none",
    d: "M 519.762207 372.132416 C 519.762207 372.132416 513.11731 384.606598 512.698303 393.359741 C 512.27887 402.112396 522.157043 401.476105 522.157043 401.476105 L 534.425903 401.043304 C 534.425903 401.043304 538.838989 373.759338 519.762207 372.132416 Z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient38",
    x1: 481.363592,
    y1: 443.180378,
    x2: 521.893294,
    y2: 356.578494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#26264f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    fill: "url(#linearGradient38)",
    stroke: "none",
    d: "M 522.454224 398.01181 C 520.379333 405.043427 524.074524 411.980316 526.284851 416.205994 C 532.036438 427.201752 540.253723 425.45871 548.09198 434.435577 C 558.579712 446.447174 550.217346 456.839172 558.749634 471.423828 C 565.918396 483.677979 581.711243 493.246887 596.991577 492.112152 C 619.597595 490.43335 637.51001 465.593445 637.114258 441.95874 C 636.713867 418.050476 617.627136 398.23645 599.499146 393.686066 C 583.176697 389.588623 574.131653 399.497833 561.884155 391.805328 C 549.992004 384.335846 552.715759 371.347839 539.942017 366.101685 C 531.900574 362.79895 520.395874 363.664703 516.708496 369.761505 C 514.647949 373.168457 514.777893 378.627777 516.929138 382.41037 C 519.235413 386.465546 522.965698 386.832916 523.890442 390.82962 C 524.530762 393.595398 523.212402 395.441956 522.454224 398.01181 Z"
  }))), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient39",
    x1: 494.779666,
    y1: 392.589043,
    x2: 540.934607,
    y2: 462.537688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9085",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb6fbb",
    stopOpacity: 1
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "path47",
    fill: "url(#linearGradient39)",
    stroke: "none",
    d: "M 437.165161 426.004822 C 456.811127 440.310669 461.892456 436.605438 468.445587 433.671875 C 473.720276 431.310394 477.530182 426.166595 493.082275 416.041473 C 495.877136 414.222473 498.230652 412.776123 499.844086 411.802948 C 506.688843 422.672455 515.61499 425.018555 522.459717 435.888336 C 522.459717 435.888336 463.658997 487.539978 433.576141 433.30014 L 437.165161 426.004822 Z"
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient40",
    x1: 437.022112,
    y1: 419.838159,
    x2: 439.863457,
    y2: 438.509876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996403,
    stopColor: "#f36f56",
    stopOpacity: 1
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "path48",
    fill: "url(#linearGradient40)",
    stroke: "none",
    d: "M 436.893219 427.577637 C 436.893219 427.577637 437.095184 423.441895 434.682983 420.708679 C 432.270691 417.975433 425.196472 421.789703 424.553375 424.143158 C 423.910187 426.496582 434.682983 432.07019 434.682983 432.07019 L 436.893219 427.577637 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingImage);
export default __webpack_public_path__ + "static/media/waiting-image.be97133a64bb26a8ddb571377743bbd4.svg";
export { ForwardRef as ReactComponent };